import React from 'react';

const MangaCreators = ({ manga }) => {
  return (
    <div className="manga-tab-content">
      <div className="manga-creators-grid">
        <div className="manga-creator-group">
          <h4>Authors</h4>
          <div className="manga-creator-tags">
            {manga.authors?.length > 0 ? (
              manga.authors.map((author, index) => (
                <span key={index} className="manga-creator-tag">
                  {author.name}
                </span>
              ))
            ) : (
              <span className="manga-na">No authors listed</span>
            )}
          </div>
        </div>
        
        {manga.illustrators && manga.illustrators.length > 0 && (
          <div className="manga-creator-group">
            <h4>Illustrators</h4>
            <div className="manga-creator-tags">
              {manga.illustrators.map((illustrator, index) => (
                <span key={index} className="manga-creator-tag">
                  {illustrator.name}
                </span>
              ))}
            </div>
          </div>
        )}
        
        {manga.publishers && manga.publishers.length > 0 && (
          <div className="manga-creator-group">
            <h4>Publishers</h4>
            <div className="manga-creator-tags">
              {manga.publishers.map((publisher, index) => (
                <span key={index} className="manga-creator-tag">
                  {publisher}
                </span>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MangaCreators;